module.exports = __webpack_public_path__ + "static/media/grid-view-active.2960fd28.svg";